import { z } from 'zod';
import { uuidSchema } from './common';

/**
 * Create field form — POST /api/v1/fields {farm_id, name, number?, comment?}.
 *
 * Geometry (drawnPolygon) проверяется отдельно — это MapLibre side-effect,
 * не часть form-state. При submit: assert drawnPolygon !== null до отправки.
 *
 * culture_id / sowing_date — frontend-only пока (Sprint 2A backend extension,
 * см. TODO в pages/fields/new.tsx). После расширения POST — добавить
 * .refine() для ISO date / валидного culture_id.
 */

export const createFieldSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Название поля обязательно')
    .max(200, 'Не более 200 символов'),
  farm_id: uuidSchema,
  number: z.string().optional(),
  comment: z.string().optional(),
  // frontend-only пока (Sprint 2A backend pending):
  culture_id: z.string().optional(),
  sowing_date: z.string().optional(),
});
export type CreateFieldForm = z.infer<typeof createFieldSchema>;
